import { dropdownOptionsFormatter, formatDropdownItem } from "@/utils/helper";
import { useEffect, useState } from "react";

import axiosInstance from "@/Axios/ConfiguredAxios";
import { debounce } from "@mui/material";

const useModalGetOptions = ({
  modalState,
  listApi,
  formikValue = null,
  formikInitialValue = null,
  showData = null,
  labelFormatter = null,
  valueFormatter = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!modalState?.isOpen) return;

    const fetchOptions = async () => {
      setLoading(true);
      const response = await axiosInstance.get(listApi);

      if (response) {
        const formattedOptions =
          dropdownOptionsFormatter(
            response.data.data,
            labelFormatter,
            valueFormatter
          ) ?? [];

        if (
          showData &&
          !formattedOptions.some(
            (opt) =>
              opt.value ===
              (valueFormatter ? valueFormatter(showData) : showData.id)
          )
        ) {
          formattedOptions.unshift(
            formatDropdownItem(showData, labelFormatter, valueFormatter)
          );
        }

        setOptions(formattedOptions);
      }

      setLoading(false);
    };

    fetchOptions();
  }, [listApi, modalState?.isOpen, showData, labelFormatter, valueFormatter]);

  const debouncedFetchOptions = debounce(async (input, callback) => {
    setLoading(true);
    const response = await axiosInstance.get(`${listApi}${input}`);

    if (response) {
      const newOptions =
        dropdownOptionsFormatter(
          response.data.data,
          labelFormatter,
          valueFormatter
        ) ?? [];
      callback(newOptions);
    }

    setLoading(false);
  }, 500);

  const getSelectedOption = () => {
    // doesnt select anything on purpose
    if (formikValue === null && formikValue !== formikInitialValue) return null;

    return formikValue
      ? options.find((opt) => opt.value === formikValue)
      : showData?.id
      ? formatDropdownItem(showData, labelFormatter, valueFormatter)
      : null;
  };

  return {
    loading,
    defaultOptions: options,
    debouncedFetchOptions,
    getSelectedOption,
  };
};

export default useModalGetOptions;
